<template>
	<div class="list">
		<div class="list-tt">五行旺衰</div>
		<div class="list-info">
			<div v-if="infoHtml">
				<div class="wx-list" v-for="item in infoHtml.wuxing">
					<div class="wx-name">
						{{item.name}}({{item.num}}): {{item.panci}}
					</div>
					<div class="wx-bg">
						<div :class="'wx-rot '+item.mclass" :style="'width: '+item.num+'0%;'"></div>
					</div>
				</div>
				<br>
				<!-- <div>{{infoHtml.wuxingsishi}}</div> -->
				<div class="wx-tips"><span>{{infoHtml.wuqingque}} 。</span>{{infoHtml.shigan}} ，{{infoHtml.rizhu}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['wuxing'],
		data() {
			return {
				infoHtml: '',
				getWx: {
					'甲': '木',
					'乙': '木',
					'丙': '火',
					'丁': '火',
					'戊': '土',
					'己': '土',
					'庚': '金',
					'辛': '金',
					'壬': '水',
					'癸': '水',
				},
				bazi: ''
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				let type = this.wuxing.type;
				let year = this.wuxing.year;
				let month = this.wuxing.month;
				let day = this.wuxing.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.wuxing.time];
				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
					this.bazi = bazi.getYear() + bazi.getMonth() + bazi.getDay() + bazi.getTime();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}

				let baziStr = [bazi.getYear(), bazi.getMonth(), bazi.getDay(), bazi.getTime()];
				this.infoHtml = this.baziAnalyze(baziStr);
				//console.log(this.infoHtml)
			},
			baziAnalyze(baziStr) {


				const [year, month, day, hour] = baziStr;
				const yueZhi = month[1];
				const riGan = day[0];
				const gans = [year[0], month[0], day[0], hour[0]];
				const zhis = [year[1], month[1], day[1], hour[1]];

				const ganWuXing = {
					'甲': '木',
					'乙': '木',
					'丙': '火',
					'丁': '火',
					'戊': '土',
					'己': '土',
					'庚': '金',
					'辛': '金',
					'壬': '水',
					'癸': '水'
				};
				const zhiCangGan = {
					'子': ['癸'],
					'丑': ['己', '辛', '癸'],
					'寅': ['甲', '丙', '戊'],
					'卯': ['乙'],
					'辰': ['戊', '乙', '癸'],
					'巳': ['丙', '庚', '戊'],
					'午': ['丁', '己'],
					'未': ['己', '乙', '丁'],
					'申': ['庚', '壬', '戊'],
					'酉': ['辛'],
					'戌': ['戊', '辛', '丁'],
					'亥': ['壬', '甲']
				};

				// 统计所有天干+藏干
				let allGans = [...gans];
				zhis.forEach(zhi => allGans.push(...zhiCangGan[zhi]));

				// ====================== 合并：五行个数 + 判词 ======================
				const count = {
					木: 0,
					火: 0,
					土: 0,
					金: 0,
					水: 0
				};
				allGans.forEach(gan => count[ganWuXing[gan]]++);

				const 五行详情 = {
					木: {
						num: count.木,
						name: '木',
						mclass:'mu',
						panci: count.木 === 0 ? "木气全无，肝胆筋骨偏弱，仁慈不足，缺乏主见" : count.木 <= 2 ? "木气偏弱，思维平缓，人缘一般，行事缺乏魄力" : count.木 <= 4 ?
							"木气中和，仁慈有礼，思路清晰，人缘尚可" : "木气过旺，性格耿直倔强，易冲动固执，肝胆需养护"
					},
					火: {
						num: count.火,
						name: '火',
						mclass:'huo',
						panci: count.火 === 0 ? "火气全无，命局寒湿，心性冷淡，精神不足，心血、眼目易虚亏" : count.火 <= 2 ? "火气偏弱，气场不足，缺乏热情，做事魄力欠缺" : count.火 <= 4 ?
							"火气中和，待人有礼，精神饱满，做事有干劲" : "火气过旺，性子急躁易怒，心火旺易失眠、上火"
					},
					土: {
						num: count.土,
						name: '土',
						mclass:'tu',
						panci: count.土 === 0 ? "土气缺失，诚信不足，脾胃虚弱，根基不稳，缺乏依靠" : count.土 <= 3 ? "土气偏弱，定力不足，做事容易动摇，脾胃功能偏弱" : count.土 <= 6 ?
							"土气中和，稳重守信，包容心强，做事踏实靠谱" : "土气过旺，为人固执呆板，思想保守，脾胃易积滞、肥胖"
					},
					金: {
						num: count.金,
						name: '金',
						mclass:'jin',
						panci: count.金 === 0 ? "金气缺失，义气不足，决断力差，呼吸道、肺部易偏弱" : count.金 <= 2 ? "金气偏弱，行事不够果断，魄力不足，缺乏威严" : count.金 <= 4 ?
							"金气中和，讲义气、有原则，处事果断理智" : "金气过旺，性格刚硬执拗，棱角太盛，易犯小人、官非"
					},
					水: {
						num: count.水,
						name: '水',
						mclass:'shui',
						panci: count.水 === 0 ? "水气缺失，智慧不足，记性一般，肾水、泌尿根基偏弱" : count.水 <= 2 ? "水气偏弱，思虑不足，智慧内敛，记性普通" : count.水 <= 4 ?
							"水气中和，聪明机智，心思细腻，悟性较好" : "水气过旺，心思多疑敏感，情绪起伏大，肾水易虚耗"
					}
				};

				// 缺五行判断
				const lackWuxing = Object.keys(count).filter(wx => count[wx] === 0);
				const 五行缺行 = lackWuxing.length > 0 ? `缺失五行：${lackWuxing.join('、')}` : "五行齐全，无缺失";

				// 四时旺衰
				const 五行四时旺衰判词 = ["寅", "卯"].includes(yueZhi) ? "春令：木旺、火相、水休、金囚、土死｜春木旺无金则顽，春土死有火则生" : ["巳", "午"].includes(yueZhi) ?
					"夏令：火旺、土相、木休、水囚、金死｜夏火无水则燥，夏金有土则埋" : ["申", "酉"].includes(yueZhi) ? "秋令：金旺、水相、土休、火囚、木死｜秋金无火则顽，秋木有水则活" : ["亥", "子"].includes(
						yueZhi) ? "冬令：水旺、木相、金休、土囚、火死｜冬水无火则寒，冬火有木则明" :
					"四季末：土旺、金相、火休、木囚、水死｜土旺无木则壅，水死有金则生";

				// 十干旺衰
				const 十干旺衰判词 = {
					甲: "甲木参天，脱胎要火，春不容金，秋不容土，水多木浮，火多木焚",
					乙: "乙木柔藤，赖水而生，冬喜火暖，水多木漂，土多木屈",
					丙: "丙火太阳，普照万物，冬喜水济，夏忌火炎，水旺火灭",
					丁: "丁火灯烛，需木为引，冬喜火助，夏忌水克，水旺火熄",
					戊: "戊土固重，既中且正，冬寒需火，土厚喜木，水旺土流",
					己: "己土卑湿，中正蓄藏，不愁木盛，不畏水狂，火少土寒",
					庚: "庚金刚锐，需火锻炼，夏喜水济，冬忌水寒，火多金熔",
					辛: "辛金温润，需水清洗，冬喜火暖，夏忌火炎，火多金熔",
					壬: "壬水汪洋，喜土制之，冬喜木泄，夏忌水泛，土旺水止",
					癸: "癸水雨露，喜金来生，冬喜火暖，夏忌水盛，金多水浊"
				} [riGan];

				// 子平法日主旺衰判词
				const 日主旺衰专属判词 = (() => {
					const xing = ganWuXing[riGan];
					const yueXing = ["寅", "卯"].includes(yueZhi) ? "木" : ["巳", "午"].includes(yueZhi) ? "火" : ["申", "酉"].includes(
						yueZhi) ? "金" : ["亥", "子"].includes(yueZhi) ? "水" : "土";
					const 衰旺 = yueXing === xing ? "旺" : "衰";
					const 有根 = zhis.some(z => zhiCangGan[z].some(g => ganWuXing[g] === xing));
					const 有比劫 = gans.filter(g => ganWuXing[g] === xing).length > 1;
					const 强弱 = (有根 || 有比劫) ? "强" : "弱";

					if (衰旺 === "衰" && 强弱 === "强" && ["亥", "子"].includes(yueZhi) && xing === "土") {
						return `${riGan}（${xing}）生于${yueZhi}月为“衰”，但地支双土根、天干比劫林立为“强”，属“衰而强、身强财旺、寒土需暖”之局，用神在丙火、甲木。`;
					}

					return `${riGan}（${xing}）生于${yueZhi}月为“${衰旺}”，${有根?'地支有根':'无根'}、${有比劫?'天干比劫助身':'无比劫'}，为“${强弱}”，属“${衰旺}而${强弱}”之局。`;
				})();

				return {
					wuxing: 五行详情, // 个数 + 判词 合并输出
					wuqingque: 五行缺行,
					wuxingsishi: 五行四时旺衰判词,
					shigan: 十干旺衰判词,
					rizhu: 日主旺衰专属判词
				};
			}
		},
		watch: {
			wuxing(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.wx-tips{
		line-height: 28px;
	}
	.wx-tips span{
		color: #CC2535;
	}
	.wx-rot{
		height: 5px;
		border-radius: 5px;
	}
	.wx-bg .jin{
		background-color: #D4AF37;
	}
	.wx-bg .mu{
		background-color: #2E8B57;
	}
	.wx-bg .shui{
		background-color: #4169E1;
	}
	.wx-bg .huo{
		background-color: #E53935;
	}
	.wx-bg .tu{
		background-color: #A1784F;
	}
	.wx-list{
		padding-top: 10px;
		padding-bottom: 20px;
	}
	.wx-bg{
		width: 100%;
		height: 5px;
		border-radius: 5px;
		background-color: #f3f5f7;
		margin-top:10px;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/page/wuxing.vue